export enum ProfileDocumentTypes {
    BANK_AUTHORIZATION = "1",
    FISCAL_CARD = "2",
    BANK_CERTIFICATE = "3",
}
